// @ts-strict-ignore
import { captureException } from '@sentry/nextjs';

export const markDownParser = (rawContent) => {
  // Break it into sections by delimiter
  const splittedArray = rawContent.split(/===/g);
  // The first line is always noise
  splittedArray.shift();

  const results = [];
  splittedArray.forEach((section, index) => {
    // we create the ID from the sentence on the same line as delimiter
    try {
      const sectionArray = section.split('\n');
      const sectionId = sectionArray[0].trim().toLowerCase().replace(/\s/g, '-');
      results[index] = {
        sectionId,
        title: sectionArray[0].trim(),
        content: section.slice(sectionArray[0].length),
      };
    } catch (ex) {
      captureException(ex);
    }
  });

  return results;
};
